export const servicesImages: { [key: number]: any } = {
  941: {
    image: require("@/assets/images/cx_diabetes.webp"),
  },
  953: {
    image: require("@/assets/images/cx_colocacao_brinco.webp"),
  },
  954: {
    image: require("@/assets/images/cx_medida_pressao.webp"),
  },
  958: {
    image: require("@/assets/images/cx_teste_glicemia.webp"),
  },
  960: {
    image: require("@/assets/images/cx_teste_covid_anticorpos.webp"),
  },
  961: {
    image: require("@/assets/images/cx_teste_covid_antigeno.webp"),
  },
  962: {
    image: require("@/assets/images/cx_teste_covid_flu.webp"),
  },
  964: {
    image: require("@/assets/images/cx_betahcg.webp"),
  },
  967: {
    image: require("@/assets/images/cx_teste_dengue_anticorpos.webp"),
  },
  970: {
    image: require("@/assets/images/cx_teste_glicemia.webp"),
  },
  973: {
    image: require("@/assets/images/cx_teste_hemoglobina.webp"),
  },
  982: {
    image: require("@/assets/images/cx_teste_perfil_lipidico.webp"),
  },
  1013: {
    image: require("@/assets/images/cx_teste_dengue_duo.webp"),
  },
  1018: {
    image: require("@/assets/images/cx_avaliacao_glicemia_pressao.webp"),
  },
  1031: {
    image: require("@/assets/images/cx_vacina_astrazeneca.webp"),
  },
};
